import React from "react";
import Button from "components/CustomButtons/Button.js";
import { formMultaNaoAcompanhadaSteps } from "./formMultaNaoAcompanhadaSteps";
import { useCadastroMultaNaoAcompanhadaStore } from "stores/cadastroMultaNaoAcompanhadaStore";

export function FormMultaNaoAcompanhadaButtons() {
    const cadastroStore = useCadastroMultaNaoAcompanhadaStore();

    const isFirst = cadastroStore.currentStep === 0;
    const isLast = cadastroStore.currentStep + 1 >= formMultaNaoAcompanhadaSteps.length;

    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", flex: 1, marginTop: "20px" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "523px" }}>
                <Button
                    onClick={() => cadastroStore.goToPrevious()}
                    disabled={isFirst}
                    color={(!isFirst) ? "info" : undefined}
                >
                    Voltar
                </Button>

                {(isLast) ? (
                    <Button type="submit" color="info" variant="contained">
                        Revisar pedido
                    </Button>
                ) : (
                    <Button type="submit" color="info" variant="contained">
                        Avançar
                    </Button>
                )}

            </div>
        </div>
    );
}